<template>
  <vx-card v-bind:title="capitalize($t('attribute.payment'))" class="shadow-lg vs-con-loading__container">
    <div id="payment-box">
      <template v-if="paymentErrors.length > 0">
        <div class="mb-2" v-for="error in paymentErrors" :key="error.message">
          <vs-alert color="danger" icon="new_releases">
            <span>{{ error }}</span>
          </vs-alert>
        </div>
      </template>
      <div class="vx-row d-flex align-items-stretch">
        <div class="vx-col w-full lg:w-1/3 mb-3" v-if="showWallet">
          <vs-button
            @click="onClickChangePaymentMethod(paymentMethodEnum.WALLET)"
            v-bind="paymentMethodButtonProp(paymentMethodEnum.WALLET)"
          >
            <i class="material-icons">account_balance_wallet</i><br />
            <small class="font-bold text-uppercase">{{ $t("attribute.wallet") }}</small>
          </vs-button>
        </div>
        <div class="vx-col w-full lg:w-1/3 mb-3" v-if="showCreditCard">
          <vs-button
            @click="onClickChangePaymentMethod(paymentMethodEnum.CREDIT_CARD)"
            v-bind="paymentMethodButtonProp(paymentMethodEnum.CREDIT_CARD)"
          >
            <i class="material-icons">credit_card</i><br />
            <small class="font-bold text-uppercase">{{ $t("attribute.creditCard") }}</small>
          </vs-button>
        </div>
        <div
          class="vx-col w-full lg:w-1/3 mb-3"
          v-if="showCreditCard && paymentDetails[paymentMethodEnum.CREDIT_CARD].cards.length > 0"
        >
          <vs-button
            @click="onClickChangePaymentMethod(paymentMethodEnum.SAVED_CC)"
            v-bind="paymentMethodButtonProp(paymentMethodEnum.SAVED_CC)"
          >
            <i class="material-icons">credit_card</i><br />
            <small class="font-bold text-uppercase">{{ $t("attribute.savedCC") }}</small>
          </vs-button>
        </div>
        <div class="vx-col w-full lg:w-1/3 mb-3" v-if="showPayNow">
          <vs-button
            @click="onClickChangePaymentMethod(paymentMethodEnum.PAYNOW)"
            v-bind="paymentMethodButtonProp(paymentMethodEnum.PAYNOW)"
          >
            <img :src="'/images/logo/paynow-logo.png'" style="width: 100%" />
          </vs-button>
        </div>
        <div class="vx-col w-full lg:w-1/3 mb-3" v-if="paymentDetails[paymentMethodEnum.POST_PAID] && showPostPaid">
          <vs-button
            v-if="paymentDetails[paymentMethodEnum.POST_PAID].is_post_paid"
            @click="onClickChangePaymentMethod(paymentMethodEnum.POST_PAID)"
            v-bind="paymentMethodButtonProp(paymentMethodEnum.POST_PAID)"
          >
            <i class="material-icons">card_membership</i><br />
            <small class="font-bold text-uppercase">{{ $t("attribute.postPaid") }}</small>
          </vs-button>
        </div>
        <div class="vx-col w-full lg:w-1/3 mb-3" v-if="showBankTransfer">
          <vs-button
            @click="onClickChangePaymentMethod(paymentMethodEnum.BANK_TRANSFER)"
            v-bind="paymentMethodButtonProp(paymentMethodEnum.BANK_TRANSFER)"
          >
            <i class="material-icons">account_balance</i><br />
            <small class="font-bold text-uppercase">{{ $t("attribute.bankTransfer") }}</small>
          </vs-button>
        </div>
      </div>

      <vs-divider />

      <!-----WALLET----->
      <div class="vx-row w-full" v-if="paymentMethod == paymentMethodEnum.WALLET">
        <template v-for="(wallet, index) in paymentDetails[paymentMethodEnum.WALLET]">
          <div
            class="vx-col w-full lg:w-1/2"
            :key="`wallet_${index}`"
            v-if="wallet.currency.code == $store.getters.getUserCountry.currency.code"
          >
            <vs-button
              class="w-full p-3 m-1"
              :key="`WALLET_${index}_${selectedWallet.id}`"
              :color="renderWalletButtonColor(wallet)"
              :type="renderWalletButtonType(wallet)"
              @click="onClickChangeWallet(wallet), checkWalletBalanceAmount(wallet)"
              :disabled="checkIfDisabledWallet(wallet) || loadingBtnCheckout"
            >
              <p class="font-bold">{{ wallet.currency.symbol }} {{ wallet.amount }}</p>
              <small>{{ wallet.currency.code }} {{ wallet.currency.name }}</small>
            </vs-button>
          </div>
        </template>
      </div>
      <!-----END WALLET----->

      <!-----SAVED CREDIT CARD----->
      <div class="vx-row w-full" v-if="paymentMethod == paymentMethodEnum.SAVED_CC && showCreditCard">
        <div
          class="vx-col w-full lg:w-1/2"
          v-for="(saved_cc, index) in paymentDetails[paymentMethodEnum.CREDIT_CARD].cards"
          :key="`credit_card_${index}`"
        >
          <vs-button
            class="w-full p-3 m-1"
            :key="`CREDIT_CARD_${index}_${selectedCreditCard.id}`"
            :color="renderSavedCCButtonColor(saved_cc)"
            :type="renderSavedCCButtonType(saved_cc)"
            @click="onClickChangeSavedCC(saved_cc)"
            :disabled="loadingBtnCheckout"
          >
            <div class="flex justify-between flex-wrap">
              <div class="font-bold">
                {{ saved_cc.brand ? saved_cc.brand.toUpperCase() : "no_brand" }}
              </div>
              <div>{{ saved_cc.exp_month ? saved_cc.exp_month + " / " : "" }}{{ saved_cc.exp_year }}</div>
            </div>
            <small>{{ saved_cc.last4 ? "**** **** **** " + saved_cc.last4 : "" }}</small>
          </vs-button>
        </div>
      </div>
      <vs-divider
        v-if="
          paymentMethod == paymentMethodEnum.SAVED_CC &&
            showCreditCard &&
            paymentDetails[paymentMethodEnum.CREDIT_CARD].cards.length > 0
        "
      />
      <!-----END SAVED CREDIT CARD----->

      <!-----CREDIT CARD----->
      <div class="small mb-2" v-if="paymentMethod == paymentMethodEnum.CREDIT_CARD && showCreditCard">
        {{ $t("paymentMethod.orInputCardNumber") }}
      </div>
      <stripe-component
        v-if="paymentMethod == paymentMethodEnum.CREDIT_CARD && showCreditCard"
        v-bind:defaultcc="selectedCreditCard.id"
        @update="selectedCreditCard = { id: 0 }"
        class="mb-3"
      ></stripe-component>
      <!-----END CREDIT CARD----->

      <!-----PAYNOW----->
      <!--<div class="small mb-2" v-if="paymentMethod == paymentMethodEnum.PAYNOW">
        <i>
          Upon checking out, please scan the QR code that will be displayed to authorize PayNow payment. If an error
          occurs in checkout process after scan process complete, please contact our customer support.
        </i>
      </div>-->
      <div class="small mb-2" v-if="paymentMethod == paymentMethodEnum.PAYNOW && showPayNow">
        <input-image
          v-bind:title="$t('action.uploadProof')"
          v-bind:desc="$t('paymentMethod.uploadProofInstr')"
          @onRemoveImage="imageProof = null"
          @onUploadImage="(file) => (imageProof = file)"
        >
        </input-image>
        <input type="hidden" name="Upload Proof" v-model="imageProof" />
        <div class="text-danger mt-2 text-sm" v-show="errors.has(`topup.Upload Proof`)">
          {{ $t("paymentMethod.proofOfTransferRequired") }}
        </div>
        <div class="w-full mb-3">
          <img :src="payNowImage" style="width: 70%; margin-left:auto; margin-right:auto" />
        </div>
      </div>
      <!-----END PAYNOW----->

      <!-----BANK TRANSFER----->
      <div class="small mb-2" v-if="paymentMethod == paymentMethodEnum.BANK_TRANSFER && showBankTransfer">
        <input-image
          v-bind:title="$t('action.uploadProof')"
          v-bind:desc="$t('paymentMethod.uploadProofInstr')"
          @onRemoveImage="imageProof = null"
          @onUploadImage="(file) => (imageProof = file)"
        >
        </input-image>
        <input type="hidden" name="Upload Proof" v-model="imageProof" />
        <div class="text-danger mt-2 text-sm" v-show="errors.has(`topup.Upload Proof`)">
          {{ $t("paymentMethod.proofOfTransferRequired") }}
        </div>
        <div class="w-full mb-3">
          <img :src="bankTransferImage" style="width: 70%; margin-left:auto; margin-right:auto" />
        </div>
      </div>
      <!-----END BANK TRANSFER----->

      <vs-button
        v-if="showCheckoutButton"
        class="w-full p-3 m-1 font-bold"
        type="gradient"
        color="primary"
        @click="processPayment()"
        :disabled="loadingBtnCheckout"
      >
        <span class="text-uppercase">CHECKOUT</span>
      </vs-button>
    </div>
    <vs-popup v-bind:title="$t('attribute.walletTopUp').toUpperCase()" :active.sync="topUpInsufficientAmountDialog">
    </vs-popup>
  </vx-card>
</template>

<script>
import Crypto from "@/helper/crypto";
import ErrorHandler from "@/helper/error_handler";
import Global from "@/helper/global";
import { createToken } from "vue-stripe-elements-plus";
import { PaymentMethodEnum } from "@/enums";

export default {
  name: "payment-box",
  props: {
    loadingBtnCheckout: {
      type: Boolean,
      default: false,
    },
    paymentMethods: {
      type: Array,
      default() {
        return [];
      },
    },
    isPostPaid: {
      type: Boolean,
      default: false,
    },
    isWallet: {
      type: Boolean,
      default: false,
    },
    isSavedCC: {
      type: Boolean,
      default: false,
    },
    isCreditCard: {
      type: Boolean,
      default: false,
    },
    isPayNow: {
      type: Boolean,
      default: false,
    },
    isBankTransfer: {
      type: Boolean,
      default: false,
    },
    chargeAmount: {
      type: Number,
      default: 0,
    },
    refreshPaymentMethod: {
      type: Boolean,
      default: false,
    },
    showCheckoutButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      processingCheckout: false,
      topUpInsufficientAmountDialog: false,
      paymentErrors: [],
      paymentMethodKey: 1,

      payNowDetail: {
        amount: null,
        intentID: null,
        clientSecret: null,
        paid: false,
      },

      paymentMethod: null,
      imageProof: null,
      selectedCreditCard: {
        id: 0,
      },
      selectedWallet: {
        id: 0,
        currency: {
          id: 0,
          code: "SGD",
          name: "Singaporean Dollar",
          symbol: "S$",
        },
        amount: 0,
      },
      paymentDetails: {
        CREDIT_CARD: {
          cards: [],
          default: null,
        },
        POST_PAID: {
          is_post_paid: false,
        },
        WALLET: [],
      },
    };
  },
  computed: {
    paymentMethodEnum() {
      return PaymentMethodEnum;
    },
    disableCheckoutButton() {
      return this.loadingBtnCheckout || this.processingCheckout;
    },
    showWallet() {
      return (
        this.isWallet ||
        this.paymentMethods.includes(PaymentMethodEnum.WALLET) ||
        this.paymentMethods.some((obj) => obj.code == PaymentMethodEnum.WALLET)
      );
    },
    showCreditCard() {
      return (
        this.isCreditCard ||
        this.paymentMethods.includes(PaymentMethodEnum.CREDIT_CARD) ||
        this.paymentMethods.some((obj) => obj.code == PaymentMethodEnum.CREDIT_CARD)
      );
    },
    showSavedCC() {
      return (
        this.isSavedCC ||
        this.paymentMethods.includes(PaymentMethodEnum.SAVED_CC) ||
        this.paymentMethods.some((obj) => obj.code == PaymentMethodEnum.SAVED_CC)
      );
    },
    showPostPaid() {
      return (
        this.isPostPaid ||
        this.paymentMethods.includes(PaymentMethodEnum.POST_PAID) ||
        this.paymentMethods.some((obj) => obj.code == PaymentMethodEnum.POST_PAID)
      );
    },
    showPayNow() {
      return (
        this.isPayNow ||
        this.paymentMethods.includes(PaymentMethodEnum.PAYNOW) ||
        this.paymentMethods.some((obj) => obj.code == PaymentMethodEnum.PAYNOW)
      );
    },
    payNowImage() {
      return this.paymentMethods.find((obj) => obj.code == PaymentMethodEnum.PAYNOW).account_image_path || null;
    },
    showBankTransfer() {
      return (
        this.isBankTransfer ||
        this.paymentMethods.includes(PaymentMethodEnum.BANK_TRANSFER) ||
        this.paymentMethods.some((obj) => obj.code == PaymentMethodEnum.BANK_TRANSFER)
      );
    },
    bankTransferImage() {
      return this.paymentMethods.find((obj) => obj.code == PaymentMethodEnum.BANK_TRANSFER).account_image_path || null;
    },
  },
  mounted() {
    this.retrievePaymentMethod();
  },
  watch: {
    refreshPaymentMethod: function(newValue, oldValue) {
      if (newValue == true) {
        this.retrievePaymentMethod();
      }
    },
  },
  methods: {
    retrievePaymentMethod() {
      this.$http
        .get(this.$endpoints.customer_payment_method)
        .then((res) => {
          this.paymentDetails = res.data.data;

          if (this.paymentMethodEnum.CREDIT_CARD in this.paymentDetails) {
            let cc_enum = this.paymentMethodEnum.CREDIT_CARD;
            if (this.paymentDetails[cc_enum].cards.length) {
              this.selectedCreditCard = this.paymentDetails[cc_enum].cards.find(
                (card) => card.id == this.paymentDetails[cc_enum].default
              );
            }
          }
        })
        .catch((err) => {
          this.paymentErrors = ErrorHandler.processErrorMessage(err);
        });
    },
    async processPayment() {
      return new Promise(async (resolve, reject) => {
        let details = {};
        let paymentSecret = {};
        let check = true;
        this.paymentErrors = [];
        this.$emit("loadingBtnCheckout", true);

        /*if (this.paymentMethod == this.paymentMethodEnum.PAYNOW && !this.payNowDetail.paid) {
          check = true;

          await this.processPayNow()
            .then((result) => {
              check = result;
            })
            .catch((err) => {
              check = false;
            });

          if (!check || !this.payNowDetail.paid) {
            reject();
            return;
          }
        }*/

        if (this.paymentMethod == this.paymentMethodEnum.WALLET && this.selectedWallet.id == 0) {
          this.paymentErrors = ["Please select payment method!"];
          reject();
          return;
        }

        details = await this.getPaymentMethodInfo().catch(() => {
          this.$emit("loadingBtnCheckout", false);
          reject();
        });
        if (details.method == this.paymentMethodEnum.CREDIT_CARD) {
          paymentSecret["stripe_token"] = details.creditCard.token;
        } else if (details.method == this.paymentMethodEnum.SAVED_CC) {
          paymentSecret["card_token"] = this.selectedCreditCard.id;
        } /*else if (details.method == this.paymentMethodEnum.PAYNOW) {
          paymentSecret["paynow_token"] = this.payNowDetail.intentID;
        }*/

        details["payment_secret"] = paymentSecret;

        if (check) {
          this.$emit("onClickCheckout", details);
          resolve(details);
        } else {
          reject();
        }
      });
    },
    async getPaymentMethodInfo() {
      let self = this;
      return new Promise(async (resolve, reject) => {
        let creditCardInfo = null;
        let method = this.paymentMethod;
        if (method == this.paymentMethodEnum.CREDIT_CARD) {
          creditCardInfo = await this.createCreditCardToken().catch((err) => {
            self.paymentErrors = [err.message];
            reject();
          });
        } else if (method == this.paymentMethodEnum.SAVED_CC) {
          method = this.paymentMethodEnum.SAVED_CC;
          creditCardInfo = this.selectedCreditCard;
        }

        resolve({
          method: method,
          wallet: this.selectedWallet,
          creditCard: creditCardInfo,
          imageProof: this.imageProof,
        });
      });
    },
    async createCreditCardToken() {
      let method = this.paymentMethod;

      let first_name = this.paymentDetails[method].meta.first_name;
      let last_name = this.paymentDetails[method].meta.last_name;

      var tokenOptions = {
        name: first_name + (last_name ? " " + last_name : ""),
      };

      return new Promise((resolve, reject) => {
        createToken(tokenOptions)
          .then((result) => {
            if (result.error) {
              reject(result.error);
            } else {
              resolve({
                card_token: result.token.card.id,
                token: result.token.id,
                last4: result.token.card.last4,
                stripe_token: result.token.id,
              });
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    onClickChangePaymentMethod(type) {
      this.paymentMethod = type;
      this.paymentMethodKey = this.paymentMethodKey + 1;
      this.selectedWallet = { id: 0 };
      this.$emit("onChangeMethod", type);
    },
    onClickChangeWallet(wallet) {
      this.selectedWallet = wallet;
    },
    onClickChangeSavedCC(card) {
      this.selectedCreditCard = card;
    },
    paymentMethodButtonProp(paymentMethod) {
      return {
        disabled: this.loadingBtnCheckout,
        class: "w-full h-full p-5 m-1",
        key: `${paymentMethod}_${this.paymentMethodKey}`,
        color: this.renderPaymentMethodButtonColor(paymentMethod),
        type: this.renderPaymentMethodButtonType(paymentMethod),
      };
    },
    renderPaymentMethodButtonType(type) {
      return this.paymentMethod === type ? "filled" : "border";
    },
    renderPaymentMethodButtonColor(type) {
      return this.paymentMethod === type ? "primary" : "primary";
    },
    renderWalletButtonType(wallet) {
      return this.selectedWallet === wallet ? "filled" : "border";
    },
    renderWalletButtonColor(wallet) {
      return this.selectedWallet === wallet ? "primary" : "primary";
    },
    renderSavedCCButtonType(card) {
      return this.selectedCreditCard === card ? "filled" : "border";
    },
    renderSavedCCButtonColor(card) {
      return this.selectedCreditCard === card ? "primary" : "primary";
    },
    checkIfDisabledWallet(wallet) {
      if (wallet.currency.code == this.$store.getters.getUserCountry.currency.code) {
        return false;
      }

      return true;
    },
    checkWalletBalanceAmount(wallet) {
      if (this.chargeAmount > wallet.amount) {
        this.$emit("checkWalletBalanceAmount", true);
      }
    },
    async processPayNow() {
      if (!this.chargeAmount) {
        this.paymentErrors = ["Please select valid payment amount!"];
        return;
      }

      this.$vs.loading({
        type: "radius",
        text: "Fetching PayNow Payment...",
      });

      if (!this.payNowDetail.intentID || !this.payNowDetail.clientSecret) {
        await this.createPayNowIntent();
      } else {
        await this.retrievePayNowIntent();
      }

      if (this.payNowDetail.amount != this.chargeAmount) {
        await this.updatePayNowIntent();
      }

      this.$vs.loading.close();

      return new Promise((resolve, reject) => {
        var stripe = Stripe(process.env.MIX_STRIPE_TOKEN);
        stripe.confirmPayNowPayment(this.payNowDetail.clientSecret).then((res) => {
          if (res.paymentIntent.status === "succeeded") {
            this.$vs.notify({
              color: "success",
              title: "VIAMOVE SYSTEM",
              text: "Successfully processed PayNow payment!",
            });

            this.payNowDetail.paid = true;
            resolve(true);
          } else {
            this.$vs.notify({
              color: "danger",
              title: "VIAMOVE SYSTEM",
              text: "Cancelled PayNow payment!",
            });

            resolve(false);
          }
        });
      });
    },
    createPayNowIntent() {
      let param = {
        amount: this.chargeAmount,
        description: "Payment using PayNow",
      };

      return this.$http
        .post(this.$endpoints.customer_paynow + "/intent", param)
        .then((res) => {
          this.payNowDetail.amount = res.data.data.amount;
          this.payNowDetail.clientSecret = res.data.data.client_secret;
          this.payNowDetail.intentID = res.data.data.id;
        })
        .catch((err) => {
          this.paymentErrors = ErrorHandler.processErrorMessage(err);
        });
    },
    retrievePayNowIntent() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(this.$endpoints.customer_paynow + "/intent/" + this.payNowDetail.intentID)
          .then((res) => {
            this.payNowDetail.amount = res.data.data.amount;
            this.payNowDetail.clientSecret = res.data.data.client_secret;
            this.payNowDetail.intentID = res.data.data.id;
            resolve(true);
          })
          .catch((err) => {
            this.createPayNowIntent() //Create new intent from previously expired intent
              .then((res) => {
                resolve(true);
              })
              .catch((err) => {
                reject(false);
              });
          });
      });
    },
    updatePayNowIntent() {
      let param = {
        intent_id: this.payNowDetail.intentID,
        amount: this.chargeAmount,
        description: "Payment using PayNow",
      };

      return this.$http
        .put(this.$endpoints.customer_paynow + "/intent", param)
        .then((res) => {
          this.payNowDetail.amount = res.data.data.amount;
          this.payNowDetail.clientSecret = res.data.data.client_secret;
          this.payNowDetail.intentID = res.data.data.id;
        })
        .catch((err) => {
          this.paymentErrors = ErrorHandler.processErrorMessage(err);
        });
    },
  },
};
</script>
